import React, { useState } from 'react';

import { FormControl, Select } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { ISOs } from 'utils/form/constants';

import { ICountrySelectProps } from './types';

const messageIdMap = {
  [ISOs.USA]: 'unitedStates',
  [ISOs.CAN]: 'canada',
} as const;

export const Disclaimer = withTypography({ variant: 'copyTwo', textAlign: 'center' });

export const CountrySelect = ({
  countries = [ISOs.USA, ISOs.CAN],
  label,
  value,
  onChange,
  testID,
  disclaimer,
}: ICountrySelectProps) => {
  const [selectedValue, setSelectedValue] = useState(value);

  const setSelectedCountry = (countryCode: string) => {
    if (onChange) {
      onChange(countryCode);
    }
    setSelectedValue(countryCode);
  };

  return (
    <FormControl>
      <FormControl.Label>{label}</FormControl.Label>
      <Select
        testID={testID}
        placeholder={
          selectedValue
            ? t(messageIdMap[selectedValue as keyof typeof messageIdMap])
            : t('selectACountry')
        }
        selectedValue={selectedValue}
        onValueChange={setSelectedCountry}
      >
        {countries?.map(countryCode => (
          <Select.Item
            key={countryCode}
            value={countryCode}
            label={t(messageIdMap[countryCode as keyof typeof messageIdMap])}
          />
        ))}
      </Select>
      {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
    </FormControl>
  );
};
